import { render, staticRenderFns } from "./FilterTransactionsPage.vue?vue&type=template&id=4fa9bee9&scoped=true&"
import script from "./FilterTransactionsPage.vue?vue&type=script&lang=ts&"
export * from "./FilterTransactionsPage.vue?vue&type=script&lang=ts&"
import style0 from "./FilterTransactionsPage.vue?vue&type=style&index=0&id=4fa9bee9&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fa9bee9",
  null
  
)

export default component.exports